import { render, staticRenderFns } from "./settingfarmer.vue?vue&type=template&id=0cbc6be9&scoped=true&"
import script from "./settingfarmer.vue?vue&type=script&lang=js&"
export * from "./settingfarmer.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./settingfarmer.vue?vue&type=style&index=1&id=0cbc6be9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc6be9",
  null
  
)

export default component.exports